import jwt_decode from "jwt-decode";

export default class JWTService {
  static decodeJWTToken<JWTJSON>(jwtToken: string): JWTJSON {
    return jwt_decode<JWTJSON>(jwtToken);
  }
}
